import React from 'react';
import Editor from '@monaco-editor/react';

interface CodeEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
}

const CodeEditor: React.FC<CodeEditorProps> = ({ value, onChange }) => {
  return (
    <div style={{ border: '1px solid #e9ecef', borderRadius: '4px', overflow: 'hidden' }}>
      <Editor
        height="200px"
        defaultLanguage="python"
        value={value}
        onChange={(val) => onChange(val || '')}
        theme="vs-light"
        options={{
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          fontSize: 14,
          fontFamily: 'Monaco, Consolas, "Courier New", monospace',
          wordWrap: 'off',
          automaticLayout: true
        }}
      />
    </div>
  );
};

export default CodeEditor;